import { get } from '@tovala/browser-apis-combinedapi'

export interface MealRatingSummaryChip {
  count: number
  id: string
  name: string
}

export interface MealRatingSummary {
  // Stars multiplied by 100, as an integer (442 is 4.42 stars)
  averageRating: number
  mealID: number
  ratingTotalCount: number
  topChips: MealRatingSummaryChip[]
}

export interface GetMealRatingSummaryRequest {
  mealID: number
}

export interface GetMealRatingSummaryResponse {
  ratingSummary: MealRatingSummary
}

export const ENDPOINTS = {
  GET_MEAL_RATING_SUMMARY: ({
    mealID,
  }: Pick<GetMealRatingSummaryRequest, 'mealID'>) => ({
    path: `/meals/${mealID}/ratingSummary`,
    version: 'v2' as const,
  }),
}

export async function getMealRatingSummary({
  mealID,
}: GetMealRatingSummaryRequest) {
  return get<GetMealRatingSummaryResponse>(
    ENDPOINTS.GET_MEAL_RATING_SUMMARY({ mealID }),
  )
}
